"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var WebMafNetworkStatus = (function (_super) {
    __extends(WebMafNetworkStatus, _super);
    function WebMafNetworkStatus(webMafBridge) {
        var _this = _super.call(this) || this;
        _this.webMafBridge = webMafBridge;
        _this.connected = true;
        _this.webMafBridge.listenToEvent('networkStatusChange', function (data) {
            var status;
            if (data.newState === 'connected') {
                status = client_lib_js_player_addons_common_player_1.ConnectionStatus.Connected;
            }
            else {
                status = client_lib_js_player_addons_common_player_1.ConnectionStatus.Disconnected;
            }
            _this.connected = status === client_lib_js_player_addons_common_player_1.ConnectionStatus.Connected;
            _this.notifyStatusChange(status);
        });
        return _this;
    }
    WebMafNetworkStatus.prototype.isConnected = function () {
        return this.connected;
    };
    return WebMafNetworkStatus;
}(client_lib_js_player_addons_common_player_1.NetworkStatus));
exports.WebMafNetworkStatus = WebMafNetworkStatus;
